export const DISTRESS_RESPONSE_STATUS = {
  NEW: { id: 'NEW', name: 'New' },
  NEW_ASSIGNED: { id: 'NEW_ASSIGNED', name: 'Assigned' },
  IN_PROGRESS_EN_ROUTE: {
    id: 'IN_PROGRESS_EN_ROUTE',
    name: 'Responder on the way',
  },
  IN_PROGRESS_ON_SITE: {
    id: 'IN_PROGRESS_ON_SITE',
    name: 'Responder arrived',
  },
  IN_PROGRESS_SAFE_ON_SITE: {
    id: 'IN_PROGRESS_SAFE_ON_SITE',
    name: 'Responder safe on site',
  },
  IN_PROGRESS_VISUAL_CONTACT: {
    id: 'IN_PROGRESS_VISUAL_CONTACT',
    name: 'Initiator Identified',
  },
  IN_PROGRESS_ALL_SAFE: {
    id: 'IN_PROGRESS_ALL_SAFE',
    name: 'Initiator safe',
  },
  RESOLVED: { id: 'RESOLVED', name: 'Emergency Resolved' },
  RESOLVED_ABORTED: { id: 'RESOLVED_ABORTED', name: 'Emergency Aborted' },
  ABORTED: { id: 'ABORTED', name: 'Emergency Aborted' },
};

export const DISTRESS_STATUS_OPTIONS = [
  DISTRESS_RESPONSE_STATUS.NEW,
  DISTRESS_RESPONSE_STATUS.NEW_ASSIGNED,
  DISTRESS_RESPONSE_STATUS.IN_PROGRESS_EN_ROUTE,
  DISTRESS_RESPONSE_STATUS.IN_PROGRESS_ON_SITE,
  DISTRESS_RESPONSE_STATUS.IN_PROGRESS_SAFE_ON_SITE,
  DISTRESS_RESPONSE_STATUS.IN_PROGRESS_VISUAL_CONTACT,
  DISTRESS_RESPONSE_STATUS.IN_PROGRESS_ALL_SAFE,
  DISTRESS_RESPONSE_STATUS.RESOLVED,
  DISTRESS_RESPONSE_STATUS.RESOLVED_ABORTED,
];
